import React from 'react'
import propTypes from 'prop-types'
import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'

const TITLE = 'Delete resource?'
const BODY = 'Are you sure you want to delete this resource? This action cannot be undone.'

const DeleteResourceConfirmationDialog = (props) => {
	const { open, onCancel, onConfirm, isDeleting, error } = props

	return (
		<Dialog open={open} onClose={isDeleting ? undefined : onCancel} maxWidth='xs' fullWidth>
			<DialogTitle>{TITLE}</DialogTitle>
			<DialogContent>
				<DialogContentText>{BODY}</DialogContentText>
				{error && <Alert severity='error'>{error}</Alert>}
			</DialogContent>
			<DialogActions>
				<Button onClick={onCancel} disabled={isDeleting}>
					Cancel
				</Button>
				<Button
					onClick={onConfirm}
					color='secondary'
					variant='contained'
					disabled={isDeleting}
					startIcon={isDeleting ? <CircularProgress size={16} color='inherit' /> : null}
				>
					{isDeleting ? 'Deleting…' : 'Delete'}
				</Button>
			</DialogActions>
		</Dialog>
	)
}

DeleteResourceConfirmationDialog.propTypes = {
	open: propTypes.bool.isRequired,
	onCancel: propTypes.func.isRequired,
	onConfirm: propTypes.func.isRequired,
	isDeleting: propTypes.bool,
	error: propTypes.string
}

DeleteResourceConfirmationDialog.defaultProps = {
	isDeleting: false,
	error: null
}

export default DeleteResourceConfirmationDialog
